module.exports = __webpack_public_path__ + "img/banner.c23472b3.svg";